import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: number;
    const show = () => {
      setVisible(true);
      timeoutId = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % purchaseNotifications.length);
        timeoutId = window.setTimeout(show, 9000);
      }, 6000);
    };
    timeoutId = window.setTimeout(show, 7000);
    return () => window.clearTimeout(timeoutId);
  }, [dismissed, index]);
  const item = purchaseNotifications[index];
  return <AnimatePresence data-id="element-206" data-mp="1gz6umgfaccrk">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed left-3 top-3 z-50 w-[calc(100%-1.5rem)] max-w-[340px] rounded-2xl border border-line bg-surface/95 p-3 pr-9 shadow-[0_20px_50px_-20px_rgba(0,0,0,1)] backdrop-blur sm:left-4 sm:top-auto sm:bottom-24 sm:w-auto" role="status" aria-live="polite" data-id="element-207" data-mp="1gynglasra8it">
          <button type="button" onClick={() => setDismissed(true)} aria-label="Fermer la notification" className="absolute right-2 top-2 rounded-md p-1 text-slate-500 transition-colors duration-150 ease-out hover:text-white" data-id="element-208" data-mp="i8a4wzvjr268">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-209" data-mp="28kg40kotdjun" />
          </button>
          <div className="flex items-start gap-3" data-id="element-210" data-mp="28imyx9tun7or">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-lime/15" data-id="element-211" data-mp="23m68ua33aj91">
              <CheckCircle2Icon className="h-5 w-5 text-lime" aria-hidden="true" data-id="element-212" data-mp="2anjjthbtab8c" />
            </span>
            <div className="min-w-0" data-id="element-213" data-mp="2fmmr78f9ktjh">
              <p className="text-[13px] font-bold leading-snug text-white" data-id="element-214" data-mp="2fpr02j3ocdgh">
                {item.name} vient d’acheter
              </p>
              <p className="truncate text-[12px] leading-snug text-slate-400" data-id="element-215" data-mp="2pmdil18j2sfc">
                Route Maladie Rénale™ · {item.place}
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-lime" data-id="element-216" data-mp="1rzwoe4v3cuxt">
                Il y a quelques instants
              </p>
            </div>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}